import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title-pages',
  templateUrl: './title-pages.component.html',
  styleUrl: './title-pages.component.scss'
})
export class TitlePagesComponent {
  @Input() titlePage: string = '';
}